import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";

interface CouponUsageTableProps {
  couponUsages: CouponUsage[];
}
export default function CouponUsageTable({
  couponUsages,
}: CouponUsageTableProps) {
  return (
    <div>
      <CTable>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                User
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm ">
              <div className="d-flex align-items-center justify-content-between">
                Registration Order
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm ">
              <div className="d-flex align-items-center justify-content-between">
                Active
              </div>
            </CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {couponUsages?.map((couponUsage) => (
            <CTableRow key={couponUsage.registrationOrder}>
              <CTableDataCell className="px-3 text-sm">
                <div className="d-flex align-items-center gap-3">
                  <img
                    src={
                      couponUsage.user?.profilePicture ??
                      `https://ui-avatars.com/api/?name=${couponUsage.user?.fullName}`
                    }
                    alt={couponUsage.user.fullName}
                    className="rounded-circle"
                    width="30"
                    height="30"
                  />
                  <p className="m-0">{couponUsage.user?.fullName}</p>
                </div>
              </CTableDataCell>
              <CTableDataCell className="p-3 text-sm">
                <div className="d-flex align-items-center gap-3">
                  <p className="m-0">{couponUsage.registrationOrder}</p>
                </div>
              </CTableDataCell>
              <CTableDataCell className="p-3 text-sm">
                {couponUsage.isActive ? "Oui" : "Non"}
              </CTableDataCell>
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>
    </div>
  );
}
